import React, { Component } from 'react';

class Home extends Component {
  render () {
    return (
      <div>
        <h1>Library Database Viewer</h1>
        <h4>View our database of books</h4>
        <br />
        <h4>Filter by Title, Author of Keyword</h4>
        <p>Click on the Keywords tag to filter by keyword</p>
        <p>Use search inputs in the books view to filter books</p>
      </div>
    )
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Pages/Home.js
 **/